import customSelect from 'custom-select';
import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('videolist');

    const init = function() {
        
        const item = el.querySelectorAll("[data-value]"),
              firstVideo = el.getElementsByTagName('li')[0].dataset.value,
              select = el.getElementsByTagName('select');
              
        let mobile, player;
    
        const initSelect = function() {
    
            const cstSel = customSelect(select);
            
            for (let i = 0; i < select.length; i ++) {
                cstSel[i].container.addEventListener('custom-select:open', (e) => { 
                    e.target.style.position = 'relative';
                    e.target.style.zIndex = '5';
                });
                
                cstSel[i].container.addEventListener('custom-select:close', (e) => { 
                    e.target.removeAttribute('style');
                });
                
                cstSel[i].select.addEventListener('change', (e) => { 
                    if (e.target.classList.contains('c-videolist__select')) {
                        window.videolist.play(e.target.value)
                    }
                });
            }
        };

        window.videolist = {
            def: function() {
                player.source = {
                    type: 'video',
                    sources: [
                        {
                            src: firstVideo,
                            provider: 'vimeo',
                        },
                    ],
                };  
            },
            destroy: function() {
                if (player != undefined) {
                    player.destroy();
                }
            },
            load: function(e) {
                videolist.play(e.currentTarget.dataset.value);
            },
            play: function(id) {
                player.source = {
                    type: 'video',
                    sources: [
                        {
                            src: id,
                            provider: 'vimeo',
                        },
                    ],
                };
            },
            player_desktop: function() {
                player = new Plyr('#player', {
                    ratio: '16:9',
                    vimeo: { 
                        sidedock: 0, 
                        controls: 0,
                    } 
                });
                videolist.def();
            },
            player_mobile: function() {
                player = new Plyr('#player', {
                    vimeo: { 
                        sidedock: 0, 
                        controls: 0,
                    } 
                });
                videolist.def();
            }
        }

        for (let i = 0; i < item.length; i++) {
            item[i].addEventListener('click', videolist.load);
        }
        
        const responsive = function() {
            if (window.innerWidth > 768) {
                if (!mobile) {
                    if (player === undefined) {
                        videolist.player_desktop();
                    }
                } else {
                    if (mobile === true) {
                        videolist.destroy();
                        
                        setTimeout(function() {
                            videolist.player_desktop();
                        }, 1000);
                        mobile = false;
                    }
                }

            } else {
                if (!mobile) {
                    videolist.destroy();
                    
                    setTimeout(function() {
                        videolist.player_mobile();
                    }, 1000);
                    mobile = true;
                }
            }           
        }
        
        select ? initSelect() : false;

        responsive();
        window.addEventListener('resize', responsive);
    };
    
    el ? init() : false; 

}, false)
